export enum FeatureCodes {
  FF__MEDICATION_MODULE = 'FF__MEDICATION_MODULE',
  FF__TRACKER_MODULE = 'FF__TRACKER_MODULE',
  FF__MEDICATION_MODULE__UNDER_MAINTENANCE = 'FF__MEDICATION_MODULE__UNDER_MAINTENANCE',
}
